import * as React from 'react';
import { Box, Stack, Typography, Dialog } from '@mui/material';
import * as JSTool from '../../store/JSTool';

import { settingActions } from '../../store/SettingSlice';
import { useSelector, useDispatch } from 'react-redux';

export default function VideoAlert(props) {

    const dispatch = useDispatch();
    const settingData = useSelector(state => state.settingData);

    function closeTap() {
        dispatch(settingActions.showVideoAlert(null));
    }

    return (
        <Dialog
            fullScreen={true}
            PaperProps={{
                style: {
                    width: '100%',
                    height: '100%',
                    backgroundColor: '#00000099',
                    boxShadow: 'none',
                    padding: 0,
                    margin: 0,
                    justifyContent: 'center',
                    alignItems: 'center',
                    backdropFilter: 'blur(5px)',
                    WebkitBackdropFilter: 'blur(5px)',
                },
            }}
            maxWidth={'1000px'}
            open={settingData.showVideoAlert != null}>

            <Stack
                sx={{
                    alignItems: 'center',
                    justifyContent: 'center',
                }} >

                <Box
                    component={'img'}
                    onClick={closeTap}
                    src={JSTool.getImgPath('close1.png')}
                    sx={{
                        alignSelf: 'flex-end',
                        cursor: 'pointer',
                        width: '20px',
                        mb: 4,
                        mr: 2,
                        transitionDuration: '0.3s',
                        '&:hover': {
                            transform: 'rotate(180deg)',
                        }

                    }} />

                {
                    (settingData.showVideoAlert != null && !JSTool.isEmpty(settingData.showVideoAlert.videoUrl)) &&
                    <Box
                        component={'video'}
                        autoPlay={true}
                        controls={true}
                        loop={true}
                        muted={false}
                        poster={settingData.showVideoAlert != null && settingData.showVideoAlert.imgUrl}
                        src={settingData.showVideoAlert != null && settingData.showVideoAlert.videoUrl}
                        sx={{
                            width: settingData.isMobile ? 1 : '800px',
                            objectFit: 'cover',
                            zIndex: 1,
                        }} />
                }

                {
                    (settingData.showVideoAlert != null && JSTool.isEmpty(settingData.showVideoAlert.videoUrl)) &&
                    <Box
                        component={'img'}
                        src={settingData.showVideoAlert != null && settingData.showVideoAlert.imgUrl}
                        sx={{
                            width: settingData.isMobile ? 1 : '800px',
                            objectFit: 'cover',
                            zIndex: 1,
                        }} />
                }



            </Stack>

        </Dialog>
    );

}